<template>
  <div class="pagination off-center">
    <span class="arrow item" @click="onClickFirstPage">
      <BaseIcon name="angle-double-left" :disabled="isInFirstPage" />
    </span>
    <span class="arrow item" @click="onClickPreviousPage">
      <BaseIcon name="chevron-left" :disabled="isInFirstPage" />
    </span>
    <span
      v-for="page in pages"
      :key="page.name"
      class="item"
      :class="{ active: isPageActive(page.name) }"
      :disabled="page.isDisabled"
      @click="onClickPage(page.name)"
      >{{ page.name }}</span
    >

    <span class="arrow item" @click="onClickNextPage">
      <BaseIcon name="chevron-right" :disabled="isInLastPage" />
    </span>
    <span class="arrow item" @click="onClickLastPage">
      <BaseIcon name="angle-double-right" :disabled="isInLastPage" />
    </span>
  </div>
</template>

<script>
import BaseButton from "@/components/base/Button";
import BaseIcon from "@/components/base/Icon";
export default {
  components: {
    BaseButton,
    BaseIcon
  },
  props: {
    maxVisible: {
      type: Number,
      required: false,
      default: 5
    },
    totalPages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    startPage() {
      if (this.currentPage === 1) {
        return 1;
      }
      if (this.currentPage === this.totalPages) {
        return this.totalPages - this.maxVisible;
      }
      return this.currentPage - 1;
    },
    pages() {
      const range = [];

      let start = 1;
      let end = this.totalPages;
      if (this.totalPages >= 5) {
        start = this.currentPage - 2 > 0 ? this.currentPage - 2 : 1;
        end =
          this.currentPage + 2 < this.totalPages
            ? this.currentPage + 2
            : this.totalPages;

        if (this.currentPage == this.totalPages) {
          start -= 2;
        }
        if (this.currentPage == this.totalPages - 1) {
          start--;
        }
        if (this.currentPage == 1) {
          end += 2;
        }
        if (this.currentPage == 2) {
          end++;
        }
      }

      for (let i = start; i <= end; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }

      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  },
  methods: {
    emitPage(page) {
      this.$emit("pagechanged", page);
    },
    isPageActive(page) {
      return this.currentPage === page;
    },
    onClickFirstPage() {
      this.emitPage(1);
    },
    onClickPreviousPage() {
      this.emitPage(this.currentPage - 1 > 0 ? this.currentPage - 1 : 1);
    },
    onClickPage(page) {
      this.emitPage(page);
    },
    onClickNextPage() {
      this.emitPage(
        this.currentPage + 1 <= this.totalPages
          ? this.currentPage + 1
          : this.totalPages
      );
    },
    onClickLastPage() {
      this.emitPage(this.totalPages);
    }
  },
  watch: {
    totalPages: function(val) {
      this.$forceUpdate()
    },
    currentPage: function(val) {
      if(val == 1) {
        this.$forceUpdate()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/variables";
@import "@/style/components/pagination";
</style>
